import React from "react";

import FloatingImage1 from "../../assets/floating-image-1.png";
import FloatingImage2 from "../../assets/floating-image-2.png";

export default function HeroSection() {
  const goToSection = (section) => {
    const sectionElement = document.getElementById(section);
    if (sectionElement) {
      sectionElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <>
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <img
          src={FloatingImage1}
          alt=""
          className="top-[40%] max-md:left-[-40%] md:left-[15%] absolute opacity-0 w-[235px] h-[304px] animate-float-1"
        />
        <img
          src={FloatingImage2}
          alt=""
          className="top-[40%] max-md:left-[-40%] md:left-[15%] absolute opacity-0 w-[235px] h-[304px] animate-float-2"
        />
        <img
          src={FloatingImage2}
          alt=""
          className="top-[30%] max-md:right-[-40%] md:right-[15%] absolute opacity-0 w-[235px] h-[304px] animate-float-1"
        />
        <img
          src={FloatingImage2}
          alt=""
          className="top-[30%] max-md:right-[-40%] md:right-[15%] absolute opacity-0 w-[235px] h-[304px] animate-float-2"
        />
      </div>
      <section className="md:hidden pt-[32px]">
        <div className="font-semibold text-[36px] text-white leading-[40px] tracking-[-0.5px]">
          Don't advertise to Gen-Z ─ Be in their{" "}
          <span className="bg-clip-text bg-gradient-to-r from-[#CAAAF4] to-[#E54098] text-transparent">
            Groupchat
          </span>
        </div>
        <div className="mt-[16px] text-[18px] text-neutral-100 leading-[24px]">
          Bereik 40.000+ jongeren via onze exclusieve WhatsApp-communities. Geen
          advertenties. Geen influencers. Alleen échte connectie.
        </div>
        <button
          onClick={() => {
            goToSection("signup");
          }}
          className="flex justify-center items-center mt-[24px] border-[#7721E5] border-[1.5px] rounded-[6px] w-full h-[52px] font-semibold text-[16px] text-white premium-button"
        >
          Meld je aan als partner
        </button>
      </section>
      <section className="max-md:hidden flex justify-center items-center w-full h-[582px]">
        <div className="flex flex-col items-center gap-[24px] text-center">
          <div className="font-semibold text-[56px] text-white leading-[62px] tracking-[-1px]">
            Don't advertise to Gen-Z <br />
            Be in their{" "}
            <span className="bg-clip-text bg-gradient-to-r from-[#CAAAF4] to-[#E54098] text-transparent">
              Groupchat
            </span>
          </div>
          <div className="text-[#EFEDF2] text-[22px] leading-[26px]">
            Bereik 40.000+ jongeren via onze exclusieve WhatsApp-
            <br />
            communities. Geen advertenties. Geen influencers.
            <br />
            Alleen échte connectie.
          </div>
          <button
            onClick={() => {
              goToSection("signup");
            }}
            className="flex justify-center items-center mt-[12px] p-[16px_20px] border-[#7721E5] border-[1.5px] rounded-[6px] font-medium text-[16px] text-white premium-button"
          >
            Meld je nu aan als partner
          </button>
        </div>
      </section>
    </>
  );
}
